<template>
  <div class="privacy-page">
    <b-container class="py-5">
      <h1 class="mb-4 text-center">{{ $t('privacy.title') }}</h1>
      <p class="text-center text-muted mb-5">{{ $t('privacy.last_updated') }}</p>
      
      <div class="content shadow-sm p-4 bg-white rounded">
        <p>{{ $t('privacy.intro_1') }}</p>
        <p>{{ $t('privacy.intro_2') }}</p>

        <h3 class="mt-4">{{ $t('privacy.collection_title') }}</h3>
        <p>{{ $t('privacy.collection_desc') }}</p>

        <h5 class="mt-3">{{ $t('privacy.personal_title') }}</h5>
        <p>{{ $t('privacy.personal_desc') }}</p>

        <h5 class="mt-3">{{ $t('privacy.usage_title') }}</h5>
        <p>{{ $t('privacy.usage_desc') }}</p>

        <h5 class="mt-3">{{ $t('privacy.cookies_title') }}</h5>
        <p>{{ $t('privacy.cookies_desc') }}</p>
        <ul>
            <li>{{ $t('privacy.cookies_list_1') }}</li>
            <li>{{ $t('privacy.cookies_list_2') }}</li>
            <li>{{ $t('privacy.cookies_list_3') }}</li>
        </ul>
        <p>{{ $t('privacy.cookies_note') }}</p>

        <h3 class="mt-4">{{ $t('privacy.use_title') }}</h3>
        <p>{{ $t('privacy.use_desc') }}</p>
        <ul>
            <li>{{ $t('privacy.use_list_1') }}</li>
            <li>{{ $t('privacy.use_list_2') }}</li>
            <li>{{ $t('privacy.use_list_3') }}</li>
            <li>{{ $t('privacy.use_list_4') }}</li>
            <li>{{ $t('privacy.use_list_5') }}</li>
            <li>{{ $t('privacy.use_list_6') }}</li>
            <li>{{ $t('privacy.use_list_7') }}</li>
            <li>{{ $t('privacy.use_list_8') }}</li>
        </ul>

        <h3 class="mt-4">{{ $t('privacy.transfer_title') }}</h3>
        <p>{{ $t('privacy.transfer_desc') }}</p>

        <h3 class="mt-4">{{ $t('privacy.disclosure_title') }}</h3>
        <h5 class="mt-3">{{ $t('privacy.legal_title') }}</h5>
        <p>{{ $t('privacy.legal_desc') }}</p>

        <h5 class="mt-3">{{ $t('privacy.third_party_title') }}</h5>
        <p>{{ $t('privacy.third_party_desc') }}</p>

        <h3 class="mt-4">5. Security of Data</h3>
        <p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>

        <h3 class="mt-4">6. Links to Other Sites</h3>
        <p>Our Service contains links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</p>

        <h3 class="mt-4">7. Changes to This Privacy Policy</h3>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<style scoped>
.content {
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
}
h3 {
    font-size: 1.25rem;
    font-weight: bold;
    color: #2c3e50;
}
h5 {
    font-size: 1.1rem;
    font-weight: 600;
    color: #34495e;
}
</style>
